import namespace from '@/store/namespace'
export default namespace('Documentos',{
    getters:[
        'GetDocLegales',
        'GetDocTecnicos',
        'GetDocumentos',
        'GetUrlEnlace'

    ],
    actions:[
        'ListaDocumentos',
        'ListaDocumentosLegales',
        'ListaDocumentosTecnicos',
        'ListaDocumentosDesistimiento',
        'ListaDocumentosDocsPosteriores',
        'ListaDocumentosOrdenFiscalizacion',
        'AdjuntarDocumentos',
        'SubirDocumentos',
        'EliminarDocumentoPajel',
        'EliminarDocumento',
        'ObtenerRAA',
        'ObtenerRAM',
        'ObtenerRAAI',
        'ObtenerAUTO',
        'ObtenerProveidoAutoDesistimiento',
        'ObtenerProveidoAutoDocsPosteriores',
        'ObtenerProveidoAutoOrdenFiscalizacion',
        'TieneDocumentoYEstaNotificado',
        'ObtenerDocumentoAdjunto',
        'ObtenerDocumentoAdjuntoOrdenFiscalizacion',
        'ObtenerDocumentoPDFSolicitudAutorizacion',
        'ObtenerDocumentoPDFSolicitudAmpliacionModificacion',
        'ObtenerFormSolicitudDesistimientoRenuncia',
        'ObtenerFormSolicitudDesistimientoRenunciaAmpl',
        'ObtenerFormSolicitudDocumentosPosteriores',
        'ObtenerFormSolicitudOrdenFiscalizacion',
        'ObtenerFormSolicitudInclusionExclusion',
        'ObtenerFormSolicitudAclaracionComplEnmi',
        'ExisteNotaMemorial',
        'ObtenerDocumentoAdjuntoPlantilla',
        'TieneDocumentoAdjunto',
        'TieneDocumentoAdjuntoOFPE',

        'ObtenerDocumentoRemisionDoc',
        'ModificarDocumentoRemisionDoc',
        'EliminarDocDetalle',
        'SubirArchivoRemision',
        'ObtenerDocumentoWORDDeclaracionVeracidadSolAutoPe',
        'ObtenerDocumentoWORDDeclaracionAnexoIISolAutoPe',
        'ObtenerDocumentoWORDDeclaracionAnexoIIISolAutoPe',
        'ObtenerDocumentoWORDDeclaracionVeracidadSolDocPost',

        'AdherirDocumentoRemisionDoc',
        'existe_aviso',
        'ObtenerDocumentoWORDDeclaracionVeracidadSolDocPostFinal',
        'ObtenerDocumentoAdjuntoPlantillaV2',
        'DownloadFileByCiteID',
        'GenerarFormularioSolcitud',
        'GenerarFormularioTramite',
        'GenerarFormularioV1',
        'DownloadFileByDocumentoId',
        'UrlResolucion'
    ],
    mutations:[
        'SetDocLegales',
        'SetDocTecnicos',
        'SetDocumentos',
        'SetUrlResolucion'
    ]
})
